<template>
	<div class="proList" ref="proList">
		<div id="test" class="about-nav wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
			<div v-for="item in $t('about.explain')">
				<span><animate-number from="1" :to="item.a" duration="2000"></animate-number><i>{{item.b}}</i></span>
				<b>{{item.c}}</b>
			</div>
		</div>
    <div class="container wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
      <el-row>
        <el-col :md="4">
					<h2>产品服务</h2>
          <h3>Products</h3>
        </el-col>
        <el-col :md="20">
          <ul class="tetleNav">
            <li v-for="item in list" :key="item.id"><router-link :to="'/product?categoryId='+item.id">{{$AppLang == 'en' ? item.name_en : item.name}}</router-link></li>
          </ul>
        </el-col>
      </el-row>
      <swiper class="myPro" :options="proOptions"  >
        <swiper-slide v-for="(proItem,index) in prodcutList" :key="proItem.id">
          <router-link :to="'/pro-details?goodsId='+proItem.id" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
            <img :src="proItem.title_pic">
            <div class="slideBg el-icon-right">
              <div class="text">
                <div>
                  <h4 class="ellipsis">{{$AppLang == 'en' ? proItem.title_en : proItem.title}}</h4>
                  <p class="ellipsis">{{$AppLang == 'en' ? proItem.subtitle_en : proItem.subtitle}}</p>
                </div>
              </div>
            </div>
          </router-link>
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <div class="more el-icon-right">
        <!-- <a href=""></a> -->
        <router-link to="/product">MORE</router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
	name: 'proList',
	data() {
		return {
      list:[],
      proOptions:{
				loop: true,
        slidesPerView: 4,
        spaceBetween: 20,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl:'.swiper-button-prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          }

        }
      },
      prodcutList:[]
		};
	},
	mounted(){
		var options={ live:false};
    var wow=new this.$wow.WOW(options).init();
		//window.addEventListener('scroll', this.watchScroll)
		
	},
	destroyed () {
		//window.removeEventListener('scroll', this.watchScroll)
	},
	methods:{
		watchScroll(){
				var proTap = this.$refs.proList;
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				if (scrollTop == proTap.getBoundingClientRect().bottom || scrollTop == proTap.getBoundingClientRect().top) {
					console.log(scrollTop);
				} else {
					console.log('scrollTop:'+scrollTop);
					console.log('top:'+proTap.getBoundingClientRect().effectTop);
					console.log('bottom:'+proTap.getBoundingClientRect().bottom);
					
				}
		}
	},
  created() {
		var that = this;
		//获取分类列表
		this.$api.post(
			'category/websiteCategorys',
			{},
			function(res) {
				// console.log(res)
				if(res.data.rtnCode== 200){
					that.list = res.data.data;
				}else{
					alert(res.data.msg);
				}
			}
		);
		//获取首页产品列表
		this.$api.post(
			'goods/homeGoods',
			{},
			function(res) {
				// console.log(res)
				if(res.data.rtnCode== 200){
					that.prodcutList = res.data.data;
				}else{
					alert(res.data.msg);
				}
			}
		);
  }
}
</script>

<style>
.proList{
  background: #fff;
  padding-bottom: 60px;
}
.proList .about-nav{
  display: flex;
  justify-content: center;
	flex-wrap: wrap;
  padding: 60px 0;
  background: #f8f8f8;
}
.proList .about-nav div{
  width: 25%;
  height: 108px;
  box-sizing: border-box;
  border-right: 1px solid rgba(0,0,0,.08);
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.proList .about-nav div:last-child{
  border-right: none;
}
.proList .about-nav span{
  font-size: 54px;
  color: #6b6b6b;
  text-align: center;
}
.proList .about-nav i{
  font-style: normal;
  font-size: 14px;
  color: #bbb;
  vertical-align: top;
}
.proList .about-nav b{
  display: block;
  font-weight: normal;
  font-size: 14px;
  color: #6b6b6b;
}
.proList .el-row{
  margin-top: 60px;
  margin-bottom: 80px;
	align-items: center;
}
.proList .tetleNav{
  display: flex;
  justify-content: flex-end;
}
.proList .tetleNav li{
  padding: 6px  26px;
  margin-left: 3px;
  color: #717171;
  font-size: 14px;
  transition: all .5s ease;
  cursor: pointer;
}
.proList .tetleNav li a{
  color: #999;
  text-decoration: none;
}

.proList .tetleNav li::before{
  content: "|";
  position: relative;
  top: 0;
  left: -29px;
  color: #e2e2e2;
}
.proList .tetleNav li:first-child::before{
  display: none;
}
.proList .tetleNav li:hover{
  background-color: #333;
  color: rgba(255,255,255,.62);
}
.proList .myPro .swiper-slide{
	overflow: hidden;
	cursor: pointer;
}
.proList .myPro .swiper-slide img{
  transition: all .3s ease;
}
.proList .myPro .swiper-slide .slideBg{
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
  opacity: 0;
  transition: all .3s ease;
}
.proList .myPro .swiper-slide .slideBg .text{
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  box-sizing: border-box;
  padding: 8% 0;
}
.proList .myPro .swiper-slide .slideBg .text div{
  transform: translateX(-10%);
  transition: all .3s ease;
}
.proList .myPro .swiper-slide .slideBg .text h4{
  font-size: 16px;
  color: #545454;
  line-height: 20px;
  text-align: center;
}
.proList .myPro .swiper-slide .slideBg .text p{
  font-size: 12px;
  color: #999;
  margin-top: 4px;
  text-align: center;
}
.proList .myPro .swiper-slide .slideBg .text::before{
  content: "";
  position: absolute;
  width: 96%;
  height: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%) scale(1.4);
  border: 1px solid rgba(51,51,51,.36);
  transition: all .3s ease;
}
.proList .myPro .swiper-slide .slideBg::before{
  font-size: 20px;
  color: #888;
  position: absolute;
  top: 50%;
  right: -20px;
  transform: translateY(-50%);
  transition: all .3s ease;
}
.proList .myPro .swiper-slide:hover .slideBg{
  opacity: 1;
}
.proList .myPro .swiper-slide:hover img{
  transform: scale(1.1);
}
.proList .myPro .swiper-slide:hover .slideBg::before{
  right: 10px;
}
.proList .myPro .swiper-slide:hover .slideBg .text div{
  transform: translateX(0);
}
.proList .myPro .swiper-slide:hover .slideBg .text::before{
  transform: translate(-50%,-50%) scale(1);
}
.proList .swiper-button-prev,.proList .swiper-button-next{
  --swiper-navigation-size: 25px;
  color: #fff;
  background: rgba(0,0,0,.6);
  z-index: 2;
	width: 56px;
	height: 56px;
	padding: 0;
	margin-top: -28px;
	overflow: hidden;
}
.proList .swiper-button-prev{
  left: 0;
}
.proList .swiper-button-prev::after,.proList .swiper-button-next::after{
	transition: all .5s ease;
}
.proList .swiper-button-next{
  right: 0;
}
.proList .swiper-button-prev::before,.proList .swiper-button-next::before{
	font-family: element-icons!important;
	font-size: 36px;
	position: absolute;
	top: 50%;
	transform: translate(-50%,-50%);
	opacity: 0;
	transition: all .5s ease;
}
.proList .swiper-button-prev::before{
	content: '\E6EA';
	left: 100%;
}
.proList .swiper-button-next::before{
	content: '\E6E9';
	left: 0;
}
.proList .swiper-button-prev:hover::before,.proList .swiper-button-next:hover::before{
	left: 50%;
	opacity: 1;
}
.proList .swiper-button-prev:hover::after,.proList .swiper-button-next:hover::after{
	opacity: 0;
}
.proList .more{
  width: 150px;
  margin: 0 auto;
  margin-top: 60px;
  border: 1px solid #9e9e9e;
  transition: all .3s ease;
  position: relative;
}
.proList .more::before{
  color: #c7c7c7;
  transition: all .3s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  right: 30%;
  transform: translate(-50%,-50%);
}
.proList .more:hover{
  background-color: #333;
}
.proList .more:hover::before{
  opacity: 1;
  right: 20%;
}
.proList .more:hover a{
  color: #fff;
  transform: translateX(-10px);
}
.proList .more a{
  font-size: 14px;
  text-decoration: none;
  color: #666;
  display: block;
  padding: 12px  0;
  transition: all .3s ease;
}

@media (max-width: 992px){
	.proList .about-nav{

	}
	.proList .about-nav div{
	  padding: 0 5px;
		width: 50%;
		margin-bottom: 10px;
	}
	.proList .about-nav span{
	  font-size: 28px;
	}
	.proList .about-nav b{
	  font-size: 12px;
	}
	.proList .about-nav i{
		font-size: 12px;
	}
  .proList h2{
		font-size: 18px;
	}
  .proList .tetleNav{
    display: none;
  }
  .proList .pro li{
    width: 49%;
  }
  .proList .pro li h5{
    margin-top: 10px;
    font-size: 14px;
  }
	.proList .swiper-button-prev,.proList .swiper-button-next{
		width: 30px;
		height: 30px;
		--swiper-navigation-size: 15px;
		margin-top: -16px;
	}
	.proList .swiper-button-prev::before,.proList .swiper-button-next::before{
		font-size: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/index/proList.vue